import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CostSection } from './components/CostSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyMobileCta } from './components/StickyMobileCta';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="w-full min-h-screen bg-bgLight font-sans text-bodyOnLight selection:bg-ctaFrom/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <ModulesSection data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <UrgencySection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <CostSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <FinalCtaSection data-id="element-12" />
      <Footer data-id="element-13" />
      <StickyMobileCta data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
    </div>;
}